'use es6';

import { Record } from 'immutable';
export default new Record({
  adAccountId: null,
  adNetwork: null,
  id: null,
  name: null
});